// Importing necessary libraries and components
import React from "react";
import PropTypes from "prop-types";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

// Custom styles for the AppLoader component
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1, // Ensures the loader appears above other elements
    color: "#fff", // Text color
    backgroundColor: "transparent", // Transparent background
  },
}));

// Functional component for displaying a loading spinner
function AppLoader(props) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={props.loader}>
      <CircularProgress style={{ color: "#3956a6" }} color="inherit" />
    </Backdrop>
  );
}

// Prop type validation for the loader prop
AppLoader.propTypes = {
  loader: PropTypes.bool, // Boolean to control the visibility of the loader
};

// Exporting the AppLoader component
export default AppLoader;
